module.exports = require("@mui/icons-material/FormatItalic");